module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/name/nobility_title_prefix.js
// module id = 981
// module chunks = 0